import React, { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AuthState from "./contexts/auth/State";
import Header from "./components/Header";
import SignIn from "./pages/SignIn";
import PrivateRoute from "./components/PrivateRoute";
import Footer from "./components/Footer";
const UnknownRoute = lazy(() => import("./pages/UnknownRoute"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Profile = lazy(() => import("./pages/Profile"));
const Questionnaire = lazy(() => import("./pages/Questionnaire"));

toast.configure({
  autoClose: 5000,
  draggable: false,
  position: toast.POSITION.BOTTOM_LEFT
});

const App = () => {
  return (
    <AuthState>
      <Header />
      <Suspense fallback={<div>Loading</div>}>
        <Switch>
          <Route exact path="/" component={SignIn} />
          <PrivateRoute path="/dashboard" component={Dashboard} />
          <PrivateRoute path="/profile" component={Profile} />
          <PrivateRoute
            path="/questionnaire/:oid/:ttype"
            component={Questionnaire}
          />
          <Route path="*">
            <UnknownRoute />
          </Route>
        </Switch>
      </Suspense>
      <Footer />
    </AuthState>
  );
};

export default App;
